import { render, staticRenderFns } from "./OverlayDeclineMessageParts.vue?vue&type=template&id=3b751a58&scoped=true"
import script from "./OverlayDeclineMessageParts.vue?vue&type=script&lang=ts"
export * from "./OverlayDeclineMessageParts.vue?vue&type=script&lang=ts"
import style0 from "./OverlayDeclineMessageParts.vue?vue&type=style&index=0&id=3b751a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b751a58",
  null
  
)

export default component.exports